module.exports = __webpack_public_path__ + "img/logo_dark.09f00f29.svg";